import { cn } from 'src/utils/className';

type AccountDisclaimersProps = {
  className?: string;
  alignment?: 'center' | 'left' | 'responsiveLeft';
};

const alignmentClassMap: Record<
  NonNullable<AccountDisclaimersProps['alignment']>,
  string
> = {
  center: 'text-center',
  left: 'text-left',
  responsiveLeft: 'text-center md:text-left',
};

export function AccountDisclaimers({
  className,
  alignment = 'center',
}: AccountDisclaimersProps) {
  return (
    <p className={cn('mt-2 text-sm', alignmentClassMap[alignment], className)}>
      By signing in or creating an account, you are agreeing to our{' '}
      <a
        className="text-underline underline"
        href="https://www.fluents.ai/terms"
        target="_blank"
        rel="noopener noreferrer"
      >
        terms of service
      </a>{' '}
      and our{' '}
      <a
        className="text-underline underline"
        href="https://www.fluents.ai/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        privacy policy
      </a>
      . This site is protected by reCAPTCHA and the Google{' '}
      <a
        className="text-underline underline"
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noreferrer"
      >
        privacy policy
      </a>{' '}
      and{' '}
      <a
        className="text-underline underline"
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noreferrer"
      >
        terms of service
      </a>{' '}
      apply.
    </p>
  );
}
